import $ from 'jquery';
import * as noUiSlider from 'nouislider';
import {connectRange} from 'instantsearch.js/es/connectors';
import {sendFilterRangeClickedEvent} from './algolia.tracking';
import {simpleDebounce} from './algolia.autocomplete';

const renderPriceRangeSlider = (renderOptions, isFirstRender) => {
    const {
        start,
        range,
        refine,
        widgetParams: {container, translations, attribute},
        instantSearchInstance
    } = renderOptions;
    const [min, max] = start;

    if (isFirstRender) {
        container.className = 'priceRangeSliderContainer';

        const slider = document.createElement('div');
        const form = document.createElement('form');
        const wrapper = document.createElement('div');
        wrapper.className = 'priceRangeSlider';
        const rowInput = document.createElement('div');
        rowInput.className = 'form-input-wrapper';

        const formInputContainerMin = document.createElement('label');
        formInputContainerMin.className = 'form-input-container';

        const formInputContainerMax = document.createElement('label');
        formInputContainerMax.className = 'form-input-container';

        const formInputDivider = document.createElement('div');
        formInputDivider.className = 'form-input-divider';

        const formInputCurrencyMin = document.createElement('span');
        formInputCurrencyMin.className = 'form-input-currency';
        formInputCurrencyMin.textContent = translations['algolia.search.filter.price.currency'];

        const formInputCurrencyMax = document.createElement('span');
        formInputCurrencyMax.className = 'form-input-currency';
        formInputCurrencyMax.textContent = translations['algolia.search.filter.price.currency'];

        const formInputLabelMin = document.createElement('span');
        formInputLabelMin.className = 'form-input-label';
        formInputLabelMin.textContent = translations['algolia.search.filter.price.label.from'];

        const formInputLabelMax = document.createElement('span');
        formInputLabelMax.className = 'form-input-label';
        formInputLabelMax.textContent = translations['algolia.search.filter.price.label.to'];


        const formInputMin = document.createElement('input');
        formInputMin.name = 'min';
        formInputMin.type = 'number';
        formInputMin.addEventListener('input', simpleDebounce((event) => {
            const min = parseInt(event.target.min, 10);
            const max = parseInt(event.target.max, 10);
            const value = parseInt(event.target.value, 10);

            if (value < min) {
                formInputMin.value = min.toString();
            }
            if (value >= max) {
                formInputMin.value = (max - 1).toString();
            }
            formInputMin.readOnly = true
            form.requestSubmit();
            setTimeout(() => {
                formInputMin.readOnly = false;
                formInputMin.focus();
            }, 250)
        }, 750));

        const formInputMax = document.createElement('input');
        formInputMax.name = 'max';
        formInputMax.type = 'number';
        formInputMax.addEventListener('input', simpleDebounce((event) => {
            const min = parseInt(event.target.min, 10);
            const max = parseInt(event.target.max, 10);
            const value = parseInt(event.target.value, 10);

            if (value <= min) {
                formInputMax.value = (min + 1).toString();
            }
            if (value > max) {
                formInputMax.value = max.toString();
            }
            formInputMax.readOnly = true
            form.requestSubmit();
            setTimeout(() => {
                formInputMax.readOnly = false;
                formInputMax.focus();
            }, 250)
        }, 750));

        formInputContainerMin.appendChild(formInputLabelMin);
        formInputContainerMin.appendChild(formInputMin);
        formInputContainerMin.appendChild(formInputCurrencyMin);

        formInputContainerMax.appendChild(formInputLabelMax);
        formInputContainerMax.appendChild(formInputMax);
        formInputContainerMax.appendChild(formInputCurrencyMax);

        rowInput.appendChild(formInputContainerMin);
        rowInput.appendChild(formInputDivider);
        rowInput.appendChild(formInputContainerMax);

        form.appendChild(rowInput);

        // Create slider instance
        noUiSlider.create(slider, {
            range: {min: 0, max: 100},
            step: 1,
            start,
            connect: true,
            format: {
                to: (value) => value,
                from: (value) => value
            }
        });

        // Refine hits on slider change
        slider.noUiSlider.on('change', ([minValue, maxValue]) => {
            refine([minValue, maxValue]);
            sendFilterRangeClickedEvent('price', minValue, maxValue);
        });

        // Update value of input fields
        slider.noUiSlider.on('slide', ([minValue, maxValue]) => {
            formInputMin.value = Math.round((minValue + Number.EPSILON) * 100) / 100;
            formInputMax.value = Math.round((maxValue + Number.EPSILON) * 100) / 100;
        });

        form.addEventListener('submit', event => {
            event.preventDefault();
            const [minInput, maxInput] = event.target.elements;
            const rawMinInputValue = parseFloat(minInput.value);
            const rawMaxInputValue = parseFloat(maxInput.value);

            refine([
                Number.isFinite(rawMinInputValue) ? rawMinInputValue : undefined,
                Number.isFinite(rawMaxInputValue) ? rawMaxInputValue : undefined
            ]);
            sendFilterRangeClickedEvent('price', rawMinInputValue, rawMaxInputValue);
        });

        const newHeader = document.createElement('div');
        newHeader.className = 'algolia-filter-panel-mobile-header';
        newHeader.innerHTML = `
            <div class="algolia-filter-panel-mobile-header__headline">${translations['algolia.search.filter.title.' + attribute]}</div>   
            <div class="d-flex">
                <button class="js-clear-price btn btn-filter btn-filter--sm">${translations['algolia.search.filter.clear']}</button>
                <button class="js-close-price btn-reset algolia-filter-panel-mobile-header__close" aria-label="${translations['algolia.search.filter.close']}">
                    <svg class="icon icon-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </button>
            </div>`;

        const newButtons = document.createElement('div');
        newButtons.className = 'algolia-filter-panel-buttons';
        newButtons.innerHTML = `
            <button class="js-clear-price btn btn-filter btn-filter--sm d-none d-md-block">${translations['algolia.search.filter.clear']}</button>
            <button class="js-submit-price btn btn-filter btn-filter--active btn-filter--sm btn-block">${translations['algolia.search.filter.apply']}</button>`;


        wrapper.appendChild(form);
        wrapper.appendChild(slider);
        container.appendChild(newHeader);
        container.appendChild(wrapper);
        container.appendChild(newButtons);

        container.querySelector('.js-submit-price').addEventListener('click', () => {
            container.querySelector('form').requestSubmit();
            $(container).closest('.algolia-filter-panel').find('.algolia-panel-collapse-button').trigger('click', ['delegate']);
            if (window.algoliaShowOverlay) {
                $('body').addClass('algolia-overlay-active');
                window.algoliaShowOverlay = false;
            }
        });

        container.querySelector('.js-close-price').addEventListener('click', () => {
            $(container).closest('.algolia-filter-panel').find('.algolia-panel-collapse-button').trigger('click', ['delegate']);
            if (window.algoliaShowOverlay) {
                $('body').addClass('algolia-overlay-active');
                window.algoliaShowOverlay = false;
            }
        });

        container.querySelectorAll('.js-clear-price').forEach((element) => {
            element.addEventListener('click', () => {
                document.querySelector(`#js-clear-refinement_${attribute} button`).click();
            })
        });
    }

    const $container = $(container);
    const slider = $container.find('.noUi-target')[0];
    const $minInput = $container.find('input[name="min"]');
    const $maxInput = $container.find('input[name="max"]');

    $container.find('.js-nbHits').text(instantSearchInstance?.helper?.lastResults?.nbHits);

    let minValue = range.min;
    if (Number.isFinite(min)) {
        minValue = min;
    }

    let maxValue = range.max;
    if (Number.isFinite(max)) {
        maxValue = max;
    }

    // Set min/max range
    if (range.min !== range.max) {
        slider.noUiSlider.updateOptions({range}, true);
        $minInput.attr('min', range.min);
        $minInput.attr('max', maxValue);
        $minInput.attr('placeholder', range.min);
        $maxInput.attr('max', range.max);
        $maxInput.attr('min', minValue);
        $maxInput.attr('placeholder', range.max);
    }

    // Set slider values
    slider.noUiSlider.set([minValue, maxValue]);
    $minInput.val(minValue);
    $maxInput.val(maxValue);
};

// Create the custom widget
const customPriceRangeSlider = connectRange(
    renderPriceRangeSlider
);

export {customPriceRangeSlider};
